<div class="flex items-center justify-center h-full px-4">
  <div class="flex w-full max-w-sm sm:max-w-md md:max-w-lg lg:w-1/4 mt-20 items-center justify-center text-center">
    <activar-card>
      <div class="flex items-center justify-center">
        <activar-icon name="success" size="80px" class="mb-5 sm:mb-6" />
      </div>

      <h2 class="text-lg sm:text-xl md:text-2xl">Pago exitoso</h2>
      <p class="text-sm sm:text-base mt-2">Ya podés descargar tu certificado.</p>
      @if(isAppClient()){
        <p class="text-sm sm:text-base mt-2">Cerrá el navegador para volver a la app.</p>
      }
      <div class="mt-5 sm:mt-6">
        @if (canDownload()) {
          <activar-button
            text="Descargar"
            color="primary"
            fill="solid"
            expand="full"
            [loading]="loading()"
            loadingText="Descargando..."
            (click)="download()"
          />
        } @else {
          <activar-button text="Descargar" color="primary" fill="solid" expand="full" [loading]="loading()" [disabled]="true"/>
        }
      </div>

    </activar-card>
  </div>
</div>